import { useConfig } from '../../../context';

export const useIsWithSelectableCurrencies = (): boolean => {
	const {
		SearchForm: { selectableCurrencies }
	} = useConfig();

	return selectableCurrencies?.length > 1;
};
